// SellerTermsModal.jsx
import React, { useState } from 'react';
import { MdOutlineLibraryBooks } from "react-icons/md";

const SellerTermsModal = ({ isOpen, onClose }) => {
    // Seller-specific terms for the e-commerce bulk orders platform
    const [terms] = useState([
        { id: 1, term: "Eligibility: Sellers must be legally registered businesses and provide valid business documentation." },
        { id: 2, term: "Account Registration: All sellers must provide accurate business details and comply with verification processes." },
        { id: 3, term: "Product Listings: Sellers are responsible for ensuring product descriptions, prices, and availability are accurate and up-to-date." },
        { id: 4, term: "Pricing and Payments: Prices must be competitive and payments will be processed according to the platform’s payout schedule." },
        { id: 5, term: "Order Fulfillment: Sellers must fulfill orders promptly and communicate shipping details clearly to buyers." },
        { id: 6, term: "Returns and Refunds: Sellers must outline their return and refund policies. Any disputes will be mediated by the platform if necessary." },
        { id: 7, term: "Compliance: Sellers must comply with all applicable laws, including tax regulations and consumer protection laws." },
        { id: 8, term: "Third-Party Liability: The platform is not responsible for any seller disputes, product defects, or non-compliance with regulations." },
        { id: 9, term: "Account Suspension: Violations of platform policies may result in suspension or termination of the seller account." },
        { id: 10, term: "Modification of Terms: The platform reserves the right to update these terms at any time, with notice provided to sellers." },
        { id: 11, term: "Governing Law: These terms are governed by the laws of the platform’s operating jurisdiction." }
    ]);

    if (!isOpen) return null;

    return (
        <>
            <style>
                {`
          .scrollbar-custom::-webkit-scrollbar {
            width: 8px;
          }
          .scrollbar-custom::-webkit-scrollbar-track {
            background: #f1f1f1;
          }
          .scrollbar-custom::-webkit-scrollbar-thumb {
            background-color: #FFAE00;
            border-radius: 4px;
            border: 2px solid #f1f1f1;
          }
          .scrollbar-custom {
            scrollbar-width: thin;
            scrollbar-color: #FFAE00 #f1f1f1;
          }
        `}
            </style>

            <div className="fixed inset-0 flex items-center justify-center z-50">
                <div
                    className="absolute inset-0 bg-black opacity-50"
                    onClick={onClose}
                ></div>
                <div className="relative bg-white rounded-lg shadow-lg h-[75vh] w-11/12 md:w-1/3 p-6 z-50 flex flex-col">
                    <div className="flex justify-center items-center mb-4">
                        <MdOutlineLibraryBooks className="text-5xl text-[#FFAE00]" />
                        <div className="ml-4">
                            <h2 className="text-lg font-bold mb-1"> Terms and Conditions</h2>
                            <p className="text-sm text-gray-600">Last updated on 01/01/2026</p>
                        </div>
                    </div>
                    <hr className="mb-4" />
                    <div className="flex-1 overflow-y-auto scrollbar-custom text-sm px-2">
                        <ol className="list-decimal pl-6 marker:text-black marker:font-semibold">
                            {terms.map((item) => (
                                <li key={item.id} className="mb-2 text-gray-500">
                                    {item.term}
                                </li>
                            ))}
                        </ol>
                    </div>

                    <div className="mt-4 flex justify-end">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 bg-[#FFAE00] text-white rounded-md"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SellerTermsModal;
